

    <ion-header>
      <ion-toolbar>
        <ion-title>{{title}}</ion-title>
        <ion-buttons slot="end">
          <ion-button fill="clear" aria-label="Copy grid data" title="Copy grid data" (click)="copyGridToClipboard()">
            <ion-icon name="copy-outline" aria-hidden="true"></ion-icon>
          </ion-button>
          <ion-button fill="clear" (click)="close()">Close</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content >
<lib-kendo-grid-parent
        [usingSignals]="false"
        [records]="data"
        [gridSettings]="{ columns: gridConfig }"
        >
      </lib-kendo-grid-parent>


    </ion-content>
